import { render, staticRenderFns } from "./BaseAlertasBloco.vue?vue&type=template&id=b3bbe1c8&scoped=true&lang=pug"
import script from "./BaseAlertasBloco.vue?vue&type=script&lang=js"
export * from "./BaseAlertasBloco.vue?vue&type=script&lang=js"
import style0 from "./BaseAlertasBloco.vue?vue&type=style&index=0&id=b3bbe1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bbe1c8",
  null
  
)

export default component.exports